import './ValuesSection.css'
import IconCardText from '../../../components/IconCardText/IconCardText'
import IconFilled from '../../../components/IconFilled/IconFilled'
import { IconNetwork, IconHeartHandshake, IconFriends, IconPawFilled, IconBrandCodesandbox, IconCertificate } from '@tabler/icons-react';
import { useAppContext } from '../../../context/AppState/AppContext';

const icons = [
   <IconNetwork className='aboutUsPage-values-icon' />,
   <IconFriends className='aboutUsPage-values-icon' />,
   <IconHeartHandshake className='aboutUsPage-values-icon' />,
   <IconCertificate className='aboutUsPage-values-icon' />,
   <IconBrandCodesandbox className='aboutUsPage-values-icon' />
];

export default function ValuesSection() {
   const { jsonTexts } = useAppContext();
   const values = jsonTexts.aboutUs.valuesSection.values;

   return (
      <div className='aboutUsPage-values-section'>
         <div className='aboutUsPage-values-section-heading'>
            <h2>VALORES</h2>
         </div>
         <div className='aboutUsPage-values-content-container'>
            {values.map((item, idx) => (
               <IconCardText
                  key={idx}
                  text={item.title}
                  description={item.description}
               >
                  <IconFilled
                     backgroundColor='var(--color-primary)'
                     rounded='var(--border-radius-sm)'
                  >
                     {icons[idx]}
                  </IconFilled>
               </IconCardText>
            ))}
         </div>
      </div>
   );
}
